import {
    Box,
    Button,
    Typography
} from '@mui/material'
import CustomerSupportBG from '../../../assets/customer-support/customer_support_bg.png'
import { ROOT_PATH,  } from '../../../common/config'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMHomeContactUs: React.FC = () => {

    const { t } = useTranslation()

    // 打开contact us
    const openContactUs = () => {
        window.open(ROOT_PATH + '/contact-us')
    }
    
    // ======================= VIEWS
    return (
        <Box sx={{
            paddingLeft: isTablet ? '40px' : '60px',
            paddingRight: isTablet ? '40px' : '60px',
            paddingBottom: '40px',
        }}>
            <Box
                sx={{
                    width: '100%',
                    height: '313px',
                    borderRadius: '10px',
                    display: 'flex',
                    alignContent: 'center',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    paddingLeft: isTablet ? '60px' : '100px',
                    paddingRight: isTablet ? '60px' : '100px',
                    backgroundImage: `url(${CustomerSupportBG})`,
                    objectFit: 'cover',
                }}>
                <Box sx={{
                    width: '600px', paddingRight: '20px',
                }}>
                    <Typography fontWeight={500} fontSize={'16px'} color={'#000000'}>
                        {t('t77')}
                    </Typography>

                    <Typography paddingTop={'15px'} fontWeight={700} fontSize={'32px'} color={'#000000'}>
                        {t('t78')}
                        {t('t79')}
                    </Typography>
                </Box>
                <Box>
                <Button onClick={openContactUs}
                    variant='contained'
                    sx={{
                        color: '#141F39',
                        mt: 6,
                        bgcolor: '#FFC107',
                        '&:hover': {
                            bgcolor: '#FFC107',
                        },
                        height: '60px',
                        width: '200px',
                        borderRadius: '50px',
                        textTransform: 'none',
                    }}
                >
                    <Typography textAlign={'center'} fontSize={15} fontWeight={500} color={'#141F39'}>
                        {t('t80')}
                    </Typography>
                </Button>
                
                </Box>
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMHomeContactUs
